$(function () {
    $(document).on('form-removed', function (e, $element, data) {
        if ($element.data('all')) {
            window.location.href = $element.data('all');
        }
    });

    $.fn.datepicker.languages['ru-Ru'] = {
        format: 'yyyy-mm-dd',
        days: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
        daysShort: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
        daysMin: ['П', 'В', 'С', 'Ч', 'Пт', 'С', 'В'],
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декаберь'],
        monthsShort: ['Янв', 'Фев', 'Мрт', 'Апр', 'Май', 'Ин', 'Ил', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        weekStart: 1,
        startView: 0,
        yearFirst: true,
        yearSuffix: 'г.'
    };

    function initDate() {
        $('[data-date]').datepicker({
            autoHide: true,
            language: 'ru-Ru',
            format: 'yyyy-mm-dd'
        });
    }
    initDate();
    $(document).ajaxComplete(function () {
        setTimeout(()=>{
            console.log('init date');
            initDate();
        }, 300);
    });


});
